// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/BusinessSortBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/BusinessSortBy.proto.
 */
export const file_Enumerations_BusinessSortBy: GenFile = /*@__PURE__*/
  fileDesc("CiFFbnVtZXJhdGlvbnMvQnVzaW5lc3NTb3J0QnkucHJvdG8SGnRpbWVfdHJhY2tpbmcuZW51bWVyYXRpb25zKsICCg5CdXNpbmVzc1NvcnRCeRIgChxCVVNJTkVTU19TT1JUX0JZX1VOU1BFQ0lGSUVEEAASJgoaQlVTSU5FU1NfU09SVF9CWV9URU5BTlRfSUQQAxoGysfNDwEDEiEKFUJVU0lORVNTX1NPUlRfQllfTkFNRRAEGgbKx80PAQQSLAogQlVTSU5FU1NfU09SVF9CWV9MT0NBVElPTlNfQ09VTlQQBhoGysfNDwEGEigKG0JVU0lORVNTX1NPUlRfQllfQ1JFQVRFRF9BVBBkGgfKx80PAmQBEikKHEJVU0lORVNTX1NPUlRfQllfTU9ESUZJRURfQVQQZRoHysfNDwJkAhIoChtCVVNJTkVTU19TT1JUX0JZX0RFTEVURURfQVQQZhoHysfNDwJkAyIECAEQASIECAIQAiIECAUQBSIECAcQY0IoqgIlTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLkVudW1lcmF0aW9uc2IGcHJvdG8z", [file_Options_EnumValueOptions]);

/**
 * Determines by which columns to sort businesses by.
 *
 * @generated from enum time_tracking.enumerations.BusinessSortBy
 */
export enum BusinessSortBy {
  /**
   * Do not apply any specific sorting to the query.
   *
   * @generated from enum value: BUSINESS_SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sort the businesses by their tenant id.
   *
   * @generated from enum value: BUSINESS_SORT_BY_TENANT_ID = 3;
   */
  TENANT_ID = 3,

  /**
   * Sort the businesses by their name.
   *
   * @generated from enum value: BUSINESS_SORT_BY_NAME = 4;
   */
  NAME = 4,

  /**
   * Sort the businesses by the number of locations they have.
   *
   * @generated from enum value: BUSINESS_SORT_BY_LOCATIONS_COUNT = 6;
   */
  LOCATIONS_COUNT = 6,

  /**
   * Sort the businesses by their creation time stamp.
   *
   * @generated from enum value: BUSINESS_SORT_BY_CREATED_AT = 100;
   */
  CREATED_AT = 100,

  /**
   * Sort the businesses by their modification time stamp.
   *
   * @generated from enum value: BUSINESS_SORT_BY_MODIFIED_AT = 101;
   */
  MODIFIED_AT = 101,

  /**
   * Sort the businesses by their deletion time stamp.
   *
   * @generated from enum value: BUSINESS_SORT_BY_DELETED_AT = 102;
   */
  DELETED_AT = 102,
}

/**
 * Describes the enum time_tracking.enumerations.BusinessSortBy.
 */
export const BusinessSortBySchema: GenEnum<BusinessSortBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_BusinessSortBy, 0);

